const settings = {}


/**
 * If browser is
 * settings.touchPlatform = [bool]
 */
settings.touchPlatform = navigator.maxTouchPoints || 'ontouchstart' in document.documentElement ? true : false
/**
 * Set screen size based on window width
 * settings.viewSize = [str] (xs|sm|md|lg|xl)
 */
settings.viewSize = 'xs'
if (window.innerWidth >= 576) { settings.viewSize = 'sm' }
if (window.innerWidth >= 768) { settings.viewSize = 'md' }
if (window.innerWidth >= 992) { settings.viewSize = 'lg' }
if (window.innerWidth >= 1200) { settings.viewSize = 'xl' }
if (window.innerWidth >= 2000) { settings.viewSize = 'xxl' }


const sap = document.getElementById('site_app')
if (sap) {
  settings.ipromUrl = sap.getAttribute('iprom')
  
  const ch = sap.getAttribute('iprom_channels_list')
  settings.ipromChannelsList = ch && ch.length ? ch.split(',') : []

  settings.google_analytics = sap.getAttribute('google_analytics')
}

settings.mail_regex = new RegExp( '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])', 'g' );

settings.recaptcha_site_key = '6Ldh3QwTAAAAALxNTS2jOZhNTHLMFJTHJGhHm487'

// settings.ella_url = window.location.href.includes('local.') ? 'http://localhost:8000' : 'https://uporabnik.delo.si'
if (window.location.href.includes('local.')) {
  settings.ella_url = 'http://local-dur.delo.si:8000'
} else if (window.location.href.includes('stage.')) {
  settings.ella_url = 'https://ella.stage.delo.si'
} else {
  settings.ella_url = 'https://uporabnik.delo.si'
}

if (location.href.includes('slovenskenovice.si')) {
    settings.ella_url = settings.ella_url.replace('.delo.si', '.slovenskenovice.si')
}

settings.site_type = (window.location.href.includes('stage') || window.location.href.includes('local')) ? 'development' : 'production'



settings.windowWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
settings.windowHeight = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;

export default settings


